module.exports = "<div mat-dialog-title>\n    {{data.title}}\n</div>\n<div mat-dialog-content>\n    <p>{{data.message}}</p>\n</div>\n<div mat-dialog-actions>\n    <button mat-button (click)=\"dialogRef.close(false)\" *ngIf=\"data.canCancel\">Cancel</button>\n    <button mat-button (click)=\"dialogRef.close(true)\" cdkFocusInitial>{{data.okString}}</button>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/user-selection/confirm-dialog/confirm-dialog.component.html
// module id = 1076
// module chunks = 0